<h2 mat-dialog-title class="text-lg font-bold mb-1">
  Nuevo Registro
</h2>
<mat-dialog-content class="modal-content">
  <div>
    <form #createForm="ngForm" class="mb-4 grid grid-cols-1 gap-4">
      <mat-form-field class="w-full">
        <mat-label class="block text-gray-700">Desde/Hasta</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
          <input matStartDate formControlName="start" placeholder="Fecha Inicio">
          <input matEndDate formControlName="end" placeholder="Fecha Fin">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="submitForm()"class="justify-end">Guardar</button>
</mat-dialog-actions>